import axios from 'axios';

const server = axios.create({
    baseURL: '',
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class MicrosFetchAPI {

    static async createCheckMicros(ip, RvcRef, employeeNum, host_url, data, token) {
        let response = await axios.post( `http://${ip}:9472/api/micros/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`, data, {
            headers: token ? { 'x-access-token': token } : undefined
          });
        return response;
    }


}

